<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Apertura Cierre Boletas
                    </v-col>
                     
            
                </v-row>

                <v-row class="col-md-12">
                    <v-col cols="12" md="3" sm="6" xs="12"  class="pt-0 mt-0">
                        <v-select
                            v-model="datosItem.periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            return-object
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            menu-props="auto"
                            @change="obtnenerBoletas"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="4" sm="6" xs="12" class="pt-0 mt-0">
                        <v-select
                            v-model="departamentoId"
                            :items="deptos"
                            class="required"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            return-object
                            menu-props="auto"
                            @change="obtnenerMunicipiosPorDepto();"
                            :rules="[
                                selectRequired(
                                    'Departamento'
                                )
                            ]"
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="5" sm="6" xs="12" class="pt-0 mt-0">
                            <v-select
                                v-model="boletaSeleccionada"
                                :items="boletas"
                                class="required"
                                dense
                                outlined
                                :loading="ddBoletasLoading"
                                label="Seleccionar Índice"
                                item-text="descripcion"
                                item-value="indicesId"
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Boleta'
                                    )
                                ]"
                                no-data-text="No se encontraron boletas"
                            >
                            <template slot='selection' slot-scope='{ item }'>
                                <v-row>
                                    <v-col cols="12">
                                        {{ item.codigo }} - {{ item.nombreIndice }} - {{ item.anioMedicion }}
                                    </v-col>
                                </v-row>
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                <v-row>
                                    <v-col cols="12">
                                        {{ item.codigo }} - {{ item.nombreIndice }} <br/> 
                                        <small class="text-overline>">{{ item.anioMedicion }}</small>
                                    </v-col>
                                </v-row>
                            </template>
                            </v-select>
                        </v-col>
                    <!--@change="obtenerAprobadoresRevisoresAsignados(); obtnenerMunicipiosPorDepto()"-->
                
                    <v-col cols="12" sm="6" md="6" xs="12" class="pt-0 mt-0">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            :disabled="datosItem.periodoMedicionId<= 0 || !datosItem.periodoMedicionId || !departamentoId || boletaSeleccionada.length <=0"
                            @click="obtnenerBoletasMuni();"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>

                    </v-col>
                    <v-col cols="12" sm="6" md="6" xs="12" class="pt-0 mt-0">

                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            :disabled="datosItem.periodoMedicionId<= 0 || !datosItem.periodoMedicionId || !departamentoId || boletaSeleccionada.length <=0 || !todosDepartamentosEnabled"
                            @click="modalTodos();"
                        >
                            Actualizar todos los municipios
                            <v-icon right>mdi-playlist-check</v-icon>
                        </v-btn>
                    </v-col> 
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>

                
                <v-row>
                    

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            append-icon="mdi-magnify"
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="boletasMuni"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.anioMedicion }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>{{ item.codigo != null ? ` ${item.codigo} - ` : '' }}{{ item.nombreMunicipio }}, {{ item.nombreDepartamento }}</td>
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosBoletaId === 1 ? 'teal' : item.estadosBoletaId=== 2 ? 'blue' : item.estadosBoletaId=== 3 || item.estadosBoletaId ===4 ? 'green' : item.estadosBoletaId ===5 ? 'red' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.nombre}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-update</v-icon> Actualizar Estado
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>


    <!-- Inicio:: Dialog para actualizar todos los municipios-->
    <v-dialog
        v-model="dialogTodos"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                <v-row class="col-md-10 col-sm-10 col-xs-10">
                    <v-col cols="12" sm="12" md="12"  class="mb-0 pb-0">
                         Actualizar todos los municipios
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                            <small class="text-h6 font-italic light-blue--text darken-3--text" v-if="boletaSeleccionada.nombreIndice">{{boletaSeleccionada.nombreIndice}}</small>
                    </v-col>
                </v-row>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialogTodos = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="actualizarTodosMunicipios"
                v-model="validFormTodos"
                >
                <v-card-text>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.periodoMedicionId"
                                :items="periodos"
                                :loading="ddPeriodosLoading"
                                dense
                                outlined
                                label="Periodo de medición"
                                item-text="anioMedicion"
                                item-value="id"
                                :disabled="true"
                                :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="estadoProcesoSeleccionado"
                                :items="estadosProceso"
                                class="required"
                                dense
                                outlined
                                item-text="nombre"
                                item-value="id"
                                :loading="ddBoletasLoading"
                                label="Seleccionar Estado"
                                :rules="[
                                    selectRequired(
                                        'Estado'
                                    )
                                ]"
                                no-data-text="No se encontraron estados"
                            >
                            </v-select>
                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="12"  class="pt-1 pb-1">
                            <v-menu
                                ref="menu1"
                                v-model="menuFechaApertura"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                                :nudge-right="40"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        outlined
                                        autocomplete="off"
                                        :rules="[
                                            required('Fecha de inicio'),
                                        ]"
                                        v-model="fechaApertura"
                                        label="Fecha Inicio"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hint="DD-MM-YYYY"
                                        class=""
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="fechas.fechaApertura" 
                                    @change="menuFechaApertura = false" 
                                    :active-picker.sync="activePicker"
                                    locale="es"
                                    :max="maxDate()"
                                    :min="minDate()"
                                    
                                ></v-date-picker>
                                <!--:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"-->
                            </v-menu>
                        
                        </v-col>

                        <v-col cols="12" md="6" sm="12"  class="pt-1 pb-1" v-if="estadoProcesoSeleccionado!=666">
                            <v-menu
                                ref="menu1"
                                v-model="menuFechaCierre"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                                :nudge-right="40"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        outlined
                                        autocomplete="off"
                                        :rules="[
                                            estadoProcesoSeleccionado!=66 ? required('Fecha de finalización') : true,
                                            estadoProcesoSeleccionado!=66 ? fechaApertura &&  fechaApertura.length > 0 ? dateGreatherThan('Fecha finalización ', fechaApertura) : true : true
                                        ]"
                                        v-model="fechaCierre"
                                        label="Fecha Finalización"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hint="DD-MM-YYYY"
                                        class=""
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="fechas.fechaCierre" 
                                    @change="menuFechaCierre = false" 
                                    :active-picker.sync="activePicker"
                                    locale="es"
                                    :max="maxDate()"
                                    :min="minDate()"
                                    
                                ></v-date-picker>
                                <!--:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"-->
                            </v-menu>
                        
                        </v-col>

                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialogTodos = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validFormTodos" 
                                :loading="btnRegistroLoading"                         
                            >
                                Actualizar Boleta
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Inicio:: Dialog para mostrar los datos de la puesto-->
    <v-dialog
        v-model="dialog"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                
                <v-row class="col-md-10 col-sm-10 col-xs-10">
                    <v-col cols="12" sm="12" md="12"  class="mb-0 pb-0">
                        {{modalTitle}}
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                            <small class="text-h6 font-italic light-blue--text darken-3--text" v-if="datosItem.nombreIndice">{{datosItem.nombreIndice}}</small>
                    </v-col>
                </v-row>
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.periodoMedicionId"
                                :items="periodos"
                                :loading="ddPeriodosLoading"
                                dense
                                outlined
                                :disabled="true"
                                label="Periodo de medición"
                                item-text="anioMedicion"
                                item-value="id"
                                :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            ></v-select>
                        </v-col>
                    </v-row>


                    <v-row v-if="tipoSeleccion==2">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            
                            <v-text-field
                                v-model="datosItem.nombreMunicipio"
                                dense
                                outlined
                                :disabled="true"
                                label="Municipio"
                                :rules="[
                                    tipoSeleccion==2 ? selectRequired(
                                        'Tipo de selección' 
                                    ): true
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="estadoProcesoSeleccionado"
                                :items="estadosProceso"
                                class="required"
                                dense
                                outlined
                                item-text="nombre"
                                item-value="id"
                                :loading="ddBoletasLoading"
                                label="Seleccionar Estado"
                                :rules="[
                                    selectRequired(
                                        'Estado'
                                    )
                                ]"
                                no-data-text="No se encontraron estados"
                            >
                            </v-select>
                        </v-col>
                    </v-row>

                    

                    <v-row v-if="tipoSeleccion==1">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            
                            <v-select
                                v-model="tipoSeleccionMunis"
                                :items="tiposSeleccion"
                                class="required"
                                dense
                                outlined
                                label="Tipo de selección"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Tipo de selección'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row v-if="tipoSeleccionMunis===2 && tipoSeleccion==1">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            
                            <v-select
                                v-model="departamentoId"
                                :items="deptos"
                                class="required"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Departamento'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="municipiosSeleccionados"
                                :items="municipios"
                                class="required"
                                dense
                                outlined
                                :no-data-text="municipios != null ? 'Seleccione una municipalidad' : 'No se han encontrado municipios'"
                                :loading="ddMunicipiosLoading"
                                label="Seleccionar municipios"
                                item-text="nombreMunicipio"
                                item-value="id"
                                multiple
                                chips
                                return-object
                                :rules="[
                                    selectRequired(
                                        'Municipio'
                                    )
                                ]"
                                
                            >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggle"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="municipiosSeleccionados.length > 0 ? 'indigo darken-4' : ''">
                                        {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                        Seleccionar todos
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                        </v-col>
                        
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="12"  class="pt-1 pb-1">
                            <v-menu
                                ref="menu1"
                                v-model="menuFechaApertura"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                                :nudge-right="40"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        outlined
                                        autocomplete="off"
                                         :rules="[
                                            required('Fecha de inicio'),
                                        ]"
                                        v-model="fechaApertura"
                                        label="Fecha Inicio"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hint="DD-MM-YYYY"
                                        class=""
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="fechas.fechaApertura" 
                                    @change="menuFechaApertura = false" 
                                    :active-picker.sync="activePicker"
                                    locale="es"
                                    :max="maxDate()"
                                    :min="minDate()"
                                    
                                ></v-date-picker>
                                <!--:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"-->
                            </v-menu>
                        
                        </v-col>

                        <v-col cols="12" md="6" sm="12"  class="pt-1 pb-1">
                            <v-menu
                                ref="menu1"
                                v-model="menuFechaCierre"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                                :nudge-right="40"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        outlined
                                        autocomplete="off"
                                        :rules="[
                                            estadoProcesoSeleccionado!=66 ? required('Fecha de finalización') : true,
                                            estadoProcesoSeleccionado!=66 ? fechaApertura &&  fechaApertura.length > 0 ? dateGreatherThan('Fecha finalización ', fechaApertura) : true : true
                                        ]"
                                        v-model="fechaCierre"
                                        label="Fecha Finalización"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hint="DD-MM-YYYY"
                                        class=""
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="fechas.fechaCierre" 
                                    @change="menuFechaCierre = false" 
                                    :active-picker.sync="activePicker"
                                    locale="es"
                                    :max="maxDate()"
                                    :min="minDate()"
                                    
                                ></v-date-picker>
                                <!--:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"-->
                            </v-menu>
                        
                        </v-col>

                    </v-row>

                    

                    

                   <!-- <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>-->

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la puesto-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";

import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_BOLETA_MUNI, OBTENER_BOLETAS_MUNI_POR_PERIODO_INDICE_DEPTO } from "@/core/services/store/boletas/boletamuni.module";
import { ACTUALIZAR_APERTURAS_CIERRES_POR_BOLETA, ACTUALIZAR_TODOS_APERTURAS_CIERRES_POR_BOLETA } from "@/core/services/store/boletas/aperturacierreboleta.module";

import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "Asigboletas",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            tableFilter:'',
            validForm:false,
            validFormTodos:false,
            itemName : "Boletas",
            dialog: false,
            dialogTodos: false,
            modalTitle: 'Actualizar Estado Boleta(s)',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            activePicker:null,
            tipoSeleccionMunis: 0,
            tiposSeleccion: [{id: 1, nombre: 'Todas las municipalidades'}, {id: 2, nombre: 'Seleccionar de forma parcial'}],
            estadosProceso: [
                {id: 1, nombre: 'Creada',disabled: true}, 
                {id: 2, nombre: 'Primera apertura para informadores'}, 
                {id: 3, nombre: 'Primera revisión'}, 
                {id: 4, nombre: 'Primera aprobación'}, 
                {id: 5, nombre: 'Segunda apertura para informadores'}, 
                {id: 6, nombre: 'Segunda revisión'}, 
                {id: 7, nombre: 'Segunda aprobación'}, 
                {id: 8, nombre: 'Cerrada'}
            ],
            estadoProcesoSeleccionado: 0,
            departamentoId: 99999,
            deptos: [],
            ddDeptosLoading: false,
            municipios: [],
            ddMunicipiosLoading: false,
            boletas: [],
            boletaSeleccionada: [{id: 0, nombre: ''}],
            boletasMuni: [],
            ddBoletasLoading: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Boleta',
            accion: 1,
            indices: [],
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            periodoMedicionId:0,
            switchItemEstado: true,
            datosItem: {
                id: 0,
                listaMunicipalidades:[],
                boletaId:0,
                estadosId: 1,
                fechaApertura: '',
                fechaCierre: '',
            },
            municipiosSeleccionados:[],
            tipoSeleccion: 1, //1 Para poder seleccionar municipios de un departamento, 2 para actualizar uno solo
            datosActualizacionBoleta: {
                boletasId:0,
                EstadosId: 1,
                EstadosBoletaId:0,
                fechaApertura: '',
                fechaCierre: '',
                listaMunicipalidades: []
            },
            periodoMedicionSeleccionado: 0,
             menuFechaApertura: false,
            menuFechaCierre:false,
            fechas: {
                fechaApertura:'',
                fechaCierre: '',
            },
            todosDepartamentosEnabled:false,
            ...validations
        } 
    }, 
    methods: {
        toggle () {
        this.$nextTick(() => {
          if (this.likesAllMunicipios) {
            this.municipiosSeleccionados = []
          } else {
            this.municipiosSeleccionados = this.municipios.slice()
          }
        })
      },

        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },

        //!Mostrar el modal para actualizar todos los municipios
        modalTodos(){
            this.tipoSeleccion =2; //Todos los municipios de GT
            this.periodoMedicionSeleccionado = this.datosItem.periodoMedicionId.id;
            this.dialogTodos = true;

        },


        modalNueva(){
            this.tipoSeleccion=1;
            this.estadoProcesoSeleccionado =null; 
            this.accion =1;
            this.modalTitle='Actualizar Estado Boleta(s)';
            this.btnRegistroText='Actualizar';
            this.switchItemEstado=true;
            this.boletaSeleccionada= [{id: 0, nombre: ''}];
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
            this.datosItem.periodoMedicionId.id ? this.periodoMedicionSeleccionado = this.datosItem.periodoMedicionId.id : this.periodoMedicionSeleccionado = this.datosItem.periodoMedicionId;
            //console.log(this.datosItem);

             this.datosItem= {
                id: 0,
                listaMunicipalidades:[],
                boletaId:0,
                estadosId: 1,
                periodoMedicionId: {id:  this.periodoMedicionSeleccionado}
            };

            this.fechas.fechaApertura = "";
            this.fechas.fechaCierre = "";
            //this.boletaSeleccionada= [{id: 0, nombre: ''}];
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;

                        //!Agregar al principio del objeto la opción "Todos los departamentos"
                        this.deptos.unshift({id: 0, nombreDepartamento: 'Todos', codigo: '000', estadosId: 1, estado: "Activo"})
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },


        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){

           // console.log(this.departamentoId)
            //!Validar que se haya seleccionado "Todos los departamentos (id 0)" para habilitar/deshabilitar el botón de actualizar todos
            this.departamentoId.id === 0 ? this.todosDepartamentosEnabled = true : this.todosDepartamentosEnabled = false;



            //console.log(this.departamentoId.id)
            this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.departamentoId.id, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading = false;
                });

        },

        //!Obtener las boletas para la llenar el dropdown
        obtnenerBoletas(){

            this.ddBoletasLoading = true;
            this.boletas=[];
            this.boletaSeleccionada=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, {estadoId: 0, idPeriodo: this.datosItem.periodoMedicionId.id, idIndice: 0})
                .then(res => {
                    if(res.status===200){
                        this.boletas = this.$store.state.boleta.boletas;
                    }
                    this.ddBoletasLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddBoletasLoading = false;
                });

        },

        //!Obtener las boletas asignadas a las municipalidades
        async obtnenerBoletasMuni(){
            //console.log(this.datosItem.periodoMedicionId)
            this.tableLoading = true;
            this.boletasMuni=[];
            
            await this.$store
                .dispatch(OBTENER_BOLETAS_MUNI_POR_PERIODO_INDICE_DEPTO, {idPeriodo: this.datosItem.periodoMedicionId.id, idIndice: this.boletaSeleccionada.indicesId, idDepto: this.departamentoId.id })
                .then(res => {
                    if(res.status===200){
                    
                        this.boletasMuni = this.$store.state.boletamuni.boletasMuni;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.tableLoading = false;
                    console.log(err)
                });

        },
        

        //!Obtener los registros para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, 0)
                .then(() => {
                    this.boletas = this.$store.state.boleta.boletas;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosItem.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Asignación';
            this.btnRegistroText='Actualizar Asignación';

            this.$store
                .dispatch(OBTENER_BOLETA_MUNI, Id)
                .then(res => {
                   
                    if(res.status===200){
                        this.datosItem = res.data;
                        this.boletaSeleccionada.id = this.datosItem.boletasId;
                        this.boletaSeleccionada.descripcion = this.datosItem.descripcion;
                        this.tipoSeleccion=2;
                        this.estadoProcesoSeleccionado = this.datosItem.estadosBoletaId;
                        //console.log(this.datosItem)
                        this.datosItem.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    //console.log(this.datosItem)
                   
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },

        registrarItem(){
            //console.log(this.accion)
            
            this.datosItem.boletaId = this.boletaSeleccionada.id;
            this.datosItem.estadosBoletaId = this.estadoProcesoSeleccionado;
            //this.datosItem.municipiosId = this.municipiosSeleccionados[0];


            
            this.btnRegistroLoading=true;
           
            this.datosActualizacionBoleta = {
                boletaId: this.boletaSeleccionada.id,
                estadosId: 1,
                estadosBoletaId: this.estadoProcesoSeleccionado,
                fechaApertura: this.datosItem.fechaApertura,
                fechaCierre: this.datosItem.fechaCierre
                
            }

            if(this.tipoSeleccion == 1){
                 this.datosActualizacionBoleta.listaMunicipalidades = this.municipiosSeleccionados.map(function(item){
                    return {
                        municipiosId: item.id,
                    };
                });
            } else {

                this.datosActualizacionBoleta.listaMunicipalidades = [{municipiosId: this.datosItem.municipiosId}]
            }
             
             console.log(this.datosActualizacionBoleta)
           // return;
            this.$store
                .dispatch(ACTUALIZAR_APERTURAS_CIERRES_POR_BOLETA, this.datosActualizacionBoleta)
                .then(res => {
                    //console.log(res)
                    if(res.status===200){
                        
                        this.dialog=false;
                        this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        this.resetForm();
                        this.obtnenerBoletasMuni();
                        //this.switchItemEstado = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(error => {
                    //console.log(error)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                    this.btnRegistroLoading=false;
                });

        },


        //!Actualizar todos los municipios de GT
        async actualizarTodosMunicipios(){

            this.datosItem.boletaId = this.boletaSeleccionada.id;
            this.datosItem.estadosBoletaId = this.estadoProcesoSeleccionado;
            //this.datosItem.municipiosId = this.municipiosSeleccionados[0];


            
            this.btnRegistroLoading=true;
           
            this.datosActualizacionBoleta = {
                boletaId: this.boletaSeleccionada.id,
                estadosId: 1,
                estadosBoletaId: this.estadoProcesoSeleccionado,
                fechaApertura: this.datosItem.fechaApertura,
                fechaCierre: this.datosItem.fechaCierre
                
            }
            
            this.$store
                .dispatch(ACTUALIZAR_TODOS_APERTURAS_CIERRES_POR_BOLETA, this.datosActualizacionBoleta)
                .then(res => {
                    //console.log(res)
                    if(res.status===200){
                        
                        this.dialog=false;
                        this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        this.resetForm();
                        this.obtnenerBoletasMuni();
                        this.dialogTodos = false;
                        //this.switchItemEstado = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(error => {
                    //console.log(error)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                    this.btnRegistroLoading=false;
                });
        }
        
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Boletas" },
            { title: "Apertura cierre" }
        ]);
    },

    created(){
       // this.obtnenerBoletasMuni();
        this.obtnenerDepartamentos();
        this.obtnenerItems();
        //this.obtnenerBoletas();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
         likesAllMunicipios () {
            return this.municipiosSeleccionados.length === this.municipios.length
        },
        likesSomeMunicipio () {
            return this.municipiosSeleccionados.length > 0 && !this.likesAllMunicipios
        },
        icon () {
            if (this.likesAllMunicipios) return 'mdi-close-box'
            if (this.likesSomeMunicipio) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Año de Medición",
                    value: "anioMedicion"
                },
                {
                    text: "Descripción Boleta",
                    value: "descripcion"
                },
                {
                    text: "Municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                 {
                    text: "Estado Proceso",
                    value: "estadosBoletasId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }   ,
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaApertura
        fechaApertura:{
            get: function(){
                return this.fechas.fechaApertura
                ? moment(this.fechas.fechaApertura).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaApertura = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
        
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaCierre
        fechaCierre:{
            get: function(){
                return this.fechas.fechaCierre
                ? moment(this.fechas.fechaCierre).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaCierre = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },  
    },

    watch: {
        
        //Cambiar el formato de fecha de apertura/cierre del objeto datosItem al momento de que fechas.fechaApertura/fechas.fechaCierre cambie
        'fechas.fechaApertura': function(val){
            this.datosItem.fechaApertura = val;
        },

        'fechas.fechaCierre': function(val){
            this.datosItem.fechaCierre = val;
        },

    
    }
    
}
</script>
<style lang="">
    
</style>